const env = require('./env.js')
const uploadPath = env.baseURL+'/file/upload';
const privateUploadPath = env.baseURL+'/file/privateUpload';
const importEmployeePath = env.baseURL+'/employee/importExcel';
const importProcessPath = env.baseURL+'/activiti/process/deploy';
const importCommodityPath = env.baseURL+'/commodity/importExcel';
const importAlaryPath = env.baseURL+'/employee/importSalaryExcel';
const importEntryAndExit = env.baseURL+'/employee/importEntryAndExit';
const importOrderDataPathContent = env.baseURL+'/orderData/importExcel/1';
const importOrderDataPathBusiness = env.baseURL+'/orderData/importExcel/2';
const importAccountRealNameInfo = env.baseURL+'/platformAccount/importAccountRealNameInfo';
const importBrandV2Path = env.baseURL+'/brandV2/import';
module.exports = {
	uploadPath: uploadPath,
	privateUploadPath: privateUploadPath,
	importEmployeePath: importEmployeePath,
	importProcessPath: importProcessPath,
	importCommodityPath: importCommodityPath,
	importAlaryPath: importAlaryPath,
	importEntryAndExit: importEntryAndExit,
	importOrderDataPathContent: importOrderDataPathContent,
	importOrderDataPathBusiness: importOrderDataPathBusiness,
	importAccountRealNameInfo: importAccountRealNameInfo,
	importBrandV2Path: importBrandV2Path,
	//文件夹
	folder:{
		common: "common",
		avatar: "avatar",
		employee: "employee",
		entry_form: "entry_form",
		official:"official",
		meeting_file:"meeting_file",
		approval_file:"approval_file",
		order_data:"order_data",
		order_agreement:"order_agreement",
		order_agreement_year_frame:"order_agreement_year_frame",
		order_agreement_supplier:"order_agreement_supplier",
		order_agreement_refund_detail:"order_agreement_refund_detail",
		order_agreement_bill : "order_agreement_bill",
		order_agreement_side : "order_agreement_side",
		customer_platform: "customer_platform",
		remaining_file: "remaining_file",
		talent_pool:"talent_pool",
		sys_info:"sys_info",
		knowledge_theory:"knowledge_theory",
		operate_income_statement: "operate_income_statement",
		award_file:"award_file",
		invoice_file:"invoice_file",
		approval_invoice_file:"approval_invoice_file",
		contract_file:"contract_file",
		account:"account"
	},
	//文件类型
	classify:{
		id_card: "id_card",//身份证
		degree_certificate: "degree_certificate",//学位证明
		resignation_certificate: "resignation_certificate",//离职证明
		entry_examination: "entry_examination",//入职体检
		bank_card_copy: "bank_card_copy",//银行卡复印件
		labor_contract: "labor_contract",//劳动合同
		internship_agreement: "internship_agreement",//实习协议
		confidentiality_agreement: "confidentiality_agreement",//保密协议
		social_security_copy: "social_security_copy",//社保复印件
		provident_fund_copy: "provident_fund_copy",//公积金复印件
		personal_photos: "personal_photos",//个人照片
		official:"official",//公告附件
		meeting_file:"meeting_file",//会议附件
		approval_file:"approval_file",//报销单
		order_data:"order_data",//口碑订单
		order_agreement:"order_agreement",// 单项合同附件
		order_agreement_year_frame:"order_agreement_year_frame",// 单项合同附件
		order_agreement_supplier:"order_agreement_supplier",// 供应商合同附件
		order_agreement_refund_detail:"order_agreement_refund_detail",// 实际回款附件
		personal_contract:'personal_contract',//个人合同
		customer_platform: 'customer_platform',//客户平台
		new_media_joined_contract: "new_media_joined_contract", // 新媒体创作人加入合同书
		face_contract : "face_contract", // 露脸协议
		new_media_remove_contract : "new_media_remove_contract",// 新媒体创作人加入合同书解除协议
		other_contract : "other_contract", // 其他附件
		redbook_joined_contract : "redbook_joined_contract", // 小红书品牌合作人补充协议
		redbook_remove_contract : "redbook_remove_contract", // 小红书品牌合作人补充协议（解约）
		order_agreement_bill : "order_agreement_bill", // 对账单附件
		order_agreement_side : "order_agreement_side", // 补充协议附件
		remaining_file: "remaining_file",// 回款凭证
		talent_pool:"talent_pool",//人才资料库
		sys_info:"sys_info",//制度资料库
		knowledge_theory:"knowledge_theory",//知识理论库
		operate_income_statement: "operate_income_statement",
		award_file:"award_file",//奖励附件
		invoice_file:"invoice_file",//申请发票附件
		approval_invoice_file:"approval_invoice_file",//审批发票附件
		contract_file:"contract_file",//（法务）签约合同附件
		monthly_account_file:"monthly_account_file"//月度账号文件
	}
};



// WEBPACK FOOTER //
// ./src/utils/fileSetting.js